(() => {
  if (customElements.get('ebike-verified-seller')) return;

  class EbikeVerifiedSeller extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const trigger = this.querySelector('[data-ebike-verified-open]');
      const dialog = this.querySelector('dialog');
      if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
      this.dialog = dialog;
      this.nextTrigger = null;

      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        dialog.showModal();
        document.documentElement.classList.add('ebike-verified-seller-open');
        trigger.setAttribute('aria-expanded', 'true');
      }, { signal });

      this.querySelectorAll('[data-ebike-verified-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close(), { signal });
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'))
          .filter((element) => element.getClientRects().length > 0);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }, { signal });

      const isBackdrop = (event) => {
        if (event.target !== dialog) return false;
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom;
      };
      let pressedBackdrop = false;
      dialog.addEventListener('pointerdown', (event) => {
        pressedBackdrop = isBackdrop(event);
      }, { signal });
      dialog.addEventListener('click', (event) => {
        if (pressedBackdrop && isBackdrop(event)) dialog.close();
        pressedBackdrop = false;
      }, { signal });

      this.querySelector('[data-ebike-verified-protection]')?.addEventListener('click', (event) => {
        const protectionTrigger = this.closest('.ebike-single-panel')?.querySelector('[data-ebike-protection-open]');
        if (!protectionTrigger) return;
        event.preventDefault();
        this.nextTrigger = protectionTrigger;
        dialog.close();
      }, { signal });

      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ebike-verified-seller-open');
        trigger.setAttribute('aria-expanded', 'false');
        const nextTrigger = this.nextTrigger;
        this.nextTrigger = null;
        if (nextTrigger?.isConnected) {
          nextTrigger.click();
        } else if (trigger.isConnected) {
          trigger.focus({ preventScroll: true });
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.classList.remove('ebike-verified-seller-open');
      }
    }
  }

  customElements.define('ebike-verified-seller', EbikeVerifiedSeller);
})();
